import * as echarts from "echarts";
import type { ZRColor } from "echarts/types/dist/shared";

export const getEchartsDefaultColors = (): ZRColor[] => {
	const tempChart = echarts.init(document.createElement("div"));
	tempChart.setOption({
		series: [],
	});
	const defaultColors = tempChart.getOption()?.color || [];
	tempChart.dispose();

	return defaultColors as ZRColor[];
};
